import { render, staticRenderFns } from "./EditConto.vue?vue&type=template&id=5bf5f15d&"
import script from "./EditConto.vue?vue&type=script&lang=ts&"
export * from "./EditConto.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports